import React from "react";
import PaymentMethod2 from "../flight/PaymentMethod2";
import ConfirmMilesPaymentModal from "../modal/ConfirmMilesPaymentModal";
import { useNavigate } from "react-router-dom";

function CommonPaymentPagePaymentOptions({
  handlePay,
  onHold,
  onWalletConfirm,
  loading,
  modalOpen,
  setModalOpen,
  service,
  booking,
}) {
  const navigate = useNavigate();

  const handleHold = () => {
    if (onHold) {
      onHold();
    } else {
      navigate("/order", { replace: true });
    }
  };

  return (
    <div className="w-full h-fit rounded-lg p-4 border border-gray-300 flex flex-col">
      <span className="font-bold w-full border-b border-gray-200 pb-2 lg:pb-4">
        Payment methods
      </span>
      <ConfirmMilesPaymentModal
        open={modalOpen}
        setOpen={setModalOpen}
        onConfirm={onWalletConfirm}
        onBack={() => setModalOpen(false)}
      />
      <PaymentMethod2
        handlePay={handlePay}
        paymentLoading={loading}
        service={service}
        booking={booking}
      />
      <button
        className={`w-full flex items-center justify-center text-white font-semibold bg-black rounded-lg mb-2 h-12`}
        disabled={loading}
        onClick={handleHold}
      >
        Pay later
      </button>
    </div>
  );
}

export default CommonPaymentPagePaymentOptions;
